import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1174 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1174 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\"><path d=\"M488.879 595.6l-321.988-331.454c-38.173-39.259-100.089-39.259-138.261 0s-38.173 103.036 0 142.295l488.957 503.388c38.173 39.259 100.087 39.259 138.261 0l488.801-503.388c38.173-39.259 38.173-103.036 0-142.295-19.087-19.707-44.070-29.483-69.209-29.483-24.983 0-49.966 9.931-69.053 29.483l-321.988 331.454-95.588 82.708-99.933-82.708z\" p-id=\"3117\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol